import { PayloadAction } from '../../../store.model';
import { createFilteredQuotesLookup } from '../function/create-filtered-quotes-lookup.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    DeleteTranscriptQuotes,
    DeleteTranscriptQuotesResult,
} from './delete-transcript-quotes.action';

export function deleteTranscriptQuotesReducer(
    state: TranscriptDialogState,
    _: PayloadAction<ActionType, DeleteTranscriptQuotes>,
): TranscriptDialogState {
    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: true,
        },
    };
}

export function deleteTranscriptQuotesResultReducer(
    state: TranscriptDialogState,
    action: PayloadAction<ActionType, DeleteTranscriptQuotesResult>,
): TranscriptDialogState {
    const quotes =
        state.transcript.quotes?.filter(
            (e) =>
                !action.payload.transcriptQuoteIds.includes(
                    e.transcriptQuoteId,
                ),
        ) ?? [];
    const filteredQuotes =
        state.filteredQuotes?.filter(
            (e) =>
                !action.payload.transcriptQuoteIds.includes(
                    e.transcriptQuoteId,
                ),
        ) ?? [];

    const { lookup: nextLookup, all: nextAllQuotesAreSelected } =
        createFilteredQuotesLookup(filteredQuotes, []);

    return {
        ...state,
        pending: {
            ...state.pending,
            updateTranscript: false,
        },
        transcript: {
            ...state.transcript,
            quotes,
        },
        filteredQuotes,
        selectedQuotes: [],
        filteredQuotesSelectedLookup: nextLookup,
        allQuotesAreSelected: nextAllQuotesAreSelected,
    };
}
